import React, { useState } from 'react';
import {
  DialogContent,
  DialogContentText,
  FormControl,
  Input,
  InputAdornment,
  FormHelperText,
} from '~/lib/bn-material-ui';
import { sirenActions, entityStore, useSirenEntity, useMeasurement } from '~/utility/BinSentry-ui-utility';
import { BnDialog } from '~/common';

export default function ConsumptionRate({ show, handleClose, href, oldRate = 0, bulkDensity }) {
  const pref = useMeasurement({ name: 'orderAmount' });
  const { entity } = useSirenEntity({ href });
  const [rate, setRate] = useState(pref.convert({ volume: oldRate, bulkDensity }));

  const setConsumptionRate = async (rate) => {
    const action = entity.getAction('update-consumption-rate');
    const fields = sirenActions.getActionFields(action);
    fields.set('consumptionRate', rate);
    await sirenActions.submitAction(action, fields);
    await entityStore.invalidateHref(entity.getLinkByRel('self').href);

    const levelsHref = entity.getSubEntityByRel('https://api.binsentry.com/rel/v2/bin-levels')?.href;
    if (levelsHref) {
      await entityStore.invalidateHref(levelsHref);
    }
  };

  const onSubmit = async () => {
    const newRate = pref.reverse({
      bulkDensity: entity.properties.bulkDensity,
      ...(pref.metric === 'weight' ? { weight: rate } : { volume: rate }),
    });
    await setConsumptionRate(newRate);
    handleClose();
  };

  return (
    <BnDialog
      open={show}
      onClose={() => handleClose()}
      title='Consumption Rate'
      onSubmit={onSubmit}
      submitLabel='Save'
    >
      <DialogContent>
        <DialogContentText>
            Consumption rate is used to calculate bin levels for standard bins. An accurate
            consumption rate is required for accurate bin levels and forecasting.
        </DialogContentText>
        <FormControl>
          <Input
            type='number'
            value={rate}
            onChange={(e) => setRate(e.target.value)}
            aria-describedby='rate-input'
            inputProps={{ min: '0' }}
            onFocus={(e) => e.target.select()}
            endAdornment={<InputAdornment position='end'>{pref.unit}/day</InputAdornment>}
          />
          <FormHelperText id='rate-input'>Current Consumption Rate</FormHelperText>
        </FormControl>
      </DialogContent>
    </BnDialog>
  );
}
